import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-link\">\r\n  <path d=\"M115.625 127.937H.063V12.375h57.781v12.374H12.438v90.813h90.813V70.156h12.374z\" />\r\n  <path d=\"M116.426 2.821l8.753 8.753-56.734 56.734-8.753-8.745z\" />\r\n  <path d=\"M127.893 37.982h-12.375V12.375H88.706V0h39.187z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol